import { useState, useCallback } from "react";
import { getAuthHeaders } from "../../auth/services/getAuthHeaders";

export function useSummaryEmail(summaryServiceUrl: string, currentMeetingId: string | null) {
  const [emailInput, setEmailInput] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailStatus, setEmailStatus] = useState<"idle" | "success" | "error">("idle");
  const [emailMessage, setEmailMessage] = useState("");

  const handleSendEmail = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    const emails = emailInput
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e);

    if (emails.length === 0) {
      setEmailStatus("error");
      setEmailMessage("Por favor ingresa al menos un correo.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    for (const email of emails) {
      if (!emailRegex.test(email)) {
        setEmailStatus("error");
        setEmailMessage(`El correo "${email}" no es válido.`);
        return;
      }
    }

    setEmailLoading(true);
    setEmailStatus("idle");

    try {
      const authHeaders = await getAuthHeaders();
      const response = await fetch(`${summaryServiceUrl}/meeting/email`, {
        method: "POST",
        headers: { ...authHeaders, "Content-Type": "application/json" },
        body: JSON.stringify({
          meeting_id: currentMeetingId,
          email: emails.join(","),
        }),
      });

      if (!response.ok) {
        throw new Error("Error en la llamada de email del servidor");
      }

      setEmailStatus("success");
      setEmailMessage(`¡Minuta enviada correctamente a ${emails.join(", ")}!`);
      setEmailInput("");
    } catch (err) {
      console.error(err);
      setEmailStatus("error");
      setEmailMessage("No se pudo enviar el correo. Revisa la configuración del servidor.");
    } finally {
      setEmailLoading(false);
      setTimeout(() => {
        setEmailStatus("idle");
        setEmailMessage("");
      }, 5000);
    }
  }, [emailInput, currentMeetingId, summaryServiceUrl]);

  const resetEmailState = useCallback(() => {
    setEmailInput("");
    setEmailStatus("idle");
    setEmailMessage("");
  }, []);

  return {
    emailInput,
    setEmailInput,
    emailLoading,
    emailStatus,
    emailMessage,
    handleSendEmail,
    resetEmailState,
  };
}
